export default __webpack_public_path__ + "static/media/2.e4c0b5b2.png";